import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { IconButton } from "components/common";
import { Label } from "components/bootstrap";
import useOwnerAction from "security-app/components/SecurityEvents/Alerts/hooks/useOwnerAction";
import useCanEditSecurityEvent from "security-app/components/SecurityEvents/Alerts/hooks/useCanEditSecurityEvent";
const FlexLabel = styled(Label)`
  padding: 0 4px;
  width: fit-content;
`;
const RemoveButton = styled(IconButton)`
  height: auto;
  width: auto;
  padding: 0px;
  color: inherit;
  font-size: inherit;
`;
const OwnerLabel = ({ securityEvent }) => {
  const { t } = useTranslation("enterprise_security_events");
  const { onRemoveOwner, selectOwner, currentOwnerName } = useOwnerAction(securityEvent);
  const canEditOwner = useCanEditSecurityEvent(securityEvent.id);
  return currentOwnerName ? /* @__PURE__ */ React.createElement(FlexLabel, null, currentOwnerName, canEditOwner && /* @__PURE__ */ React.createElement(RemoveButton, { title: t("owner_label.remove_current_owner"), name: "close", onClick: onRemoveOwner })) : canEditOwner ? /* @__PURE__ */ React.createElement(IconButton, { name: "add", onClick: selectOwner, title: t("owner_label.add_owner") }) : /* @__PURE__ */ React.createElement("i", null, t("owner_label.no_owner"));
};
export default OwnerLabel;
